
const BASE_URL_ENV = {
  TESING: 'http://127.0.0.1:8203/znrunpay',
  PRODUCTION: 'https://manager.paynow.life/znrunpay/',
  DEVELOPMENT: 'http://127.0.0.1:8203/znrunpay',
}

const { REACT_APP_RUNTINE_ENV: REACT_ENV } = process.env;
const RUNTIME_ENV = REACT_ENV && REACT_ENV !== ""
  ? REACT_ENV
  : (process.env.NODE_ENV as string).toLocaleUpperCase();

export const BASE_URL = BASE_URL_ENV[RUNTIME_ENV as keyof typeof BASE_URL_ENV]

export const APP_KEY = '71632d6c6d63616e672d3031313932303430';






